module.exports = __webpack_public_path__ + "24ca3d5bd2de24c95073e8e4e1d21365.pdf";